// AIMOTION — Shared JS for sections (fade-in observer + sticky CTA + utilities)
(function() {
  function initFadeIn() {
    const els = document.querySelectorAll('.aim-fade-in');
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('aim-visible'));
      return;
    }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('aim-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(el => obs.observe(el));
  }

  function init() {
    initFadeIn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
